import { Component, Input } from '@angular/core';

@Component({
  selector: 'digital-platform-responsive-debug',
  templateUrl: './responsive-debug.component.html',
  styleUrls: ['./responsive-debug.component.scss'],
})
export class ResponsiveDebugComponent {
  public debugElements: null[] = new Array(12).fill(null);
  public debugCls1 = 'grid-debug';
  public debugCls2 = 'grid-section-debug';
  @Input() disabled = false;
  public sections: string[] = [
    'full',
    'left',
    'right',
    'two-thirds',
    'one-third',
    'fourth',
    'fourth',
    'fourth',
    'fourth',
    'third',
    'third',
    'third',
    'half',
    'half',
    'one-fourth',
    'three-fourths',
  ];
}
